// extracted by mini-css-extract-plugin
export default {"firstCon":"About_firstCon__HbY1g","secondCon":"About_secondCon__Uz4I7","thirdCon":"About_thirdCon__tFDRg","footerCon":"About_footerCon__aYH2T"};